import './ApplicationsList.scss';
import React from "react";
import {useDispatch} from "react-redux";
import {
    CircularProgress, Pagination,
    Tooltip
} from "@mui/material";
import {
    DataGrid,
    GridColDef, gridPageCountSelector,
    gridPageSelector,
    GridValueGetterParams,
    useGridApiContext,
    useGridSelector
} from "@mui/x-data-grid";
import {dataGridCellConfig, dataGridStyles} from "../../../../../theme/styles/datagrid";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {copyContent} from "../../../../../utils/common";
import {CoreApplication} from "../../../../../packages/core-sdk/classes/core/CoreApplication";
import LinkToAccount from "../../Common/Links/LinkToAccount";
import LinkToApplication from "../../Common/Links/LinkToApplication";
import CustomNoRowsOverlay from "../../Common/CustomNoRowsOverlay/CustomNoRowsOverlay";
import {A_Application, A_AppsLocalState} from "../../../../../packages/core-sdk/types";
import Copyable from '../../../../Common/Copyable/Copyable';

interface ApplicationsListProps {
    applications: A_Application[] | A_AppsLocalState[];
    loading?: boolean;
    reachedLastPage?: Function;
    fields?: string[]
}

function ApplicationsList({applications = [], loading = false, fields = ['id', 'creator'], reachedLastPage = () => {}}: ApplicationsListProps): JSX.Element {
    const dispatch = useDispatch();

    function CustomPagination({loading}) {
        const apiRef = useGridApiContext();
        const page = useGridSelector(apiRef, gridPageSelector);
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);

        return (
            <div style={{display: "flex", justifyContent: "space-between"}}>
                {loading ? <div style={{marginTop: 5, marginRight: 20}}><CircularProgress size={25}></CircularProgress></div> : ''}
                <Pagination
                    color="primary"
                    shape="rounded"
                    showFirstButton
                    showLastButton
                    count={pageCount}
                    page={page + 1}
                    onChange={(event, value) => {
                        if (value === apiRef.current.state.pagination.pageCount) {
                            reachedLastPage();
                        }
                        return apiRef.current.setPage(value - 1);
                    }}
                />
            </div>

        );
    }

    const columns: GridColDef[] = [];

    if (fields.indexOf('id') !== -1) {
        columns.push({
            ...dataGridCellConfig,
            field: 'id',
            headerName: 'Application ID',
            renderCell: (params: GridValueGetterParams) => {
                const appInstance = new CoreApplication(params.row);
                return <div>
                    <Copyable value={appInstance.getId()} />
                    <LinkToApplication id={appInstance.getId()}></LinkToApplication>
                </div>;
            }
        });
    }
    if (fields.indexOf('creator') !== -1) {
        columns.push({
            ...dataGridCellConfig,
            field: 'creator',
            headerName: 'Creator',
            flex: 2,
            renderCell: (params: GridValueGetterParams) => {
                const appInstance = new CoreApplication(params.row);
                return <div>
                    <LinkToAccount copy="left" address={appInstance.getCreator()}></LinkToAccount>
                </div>;
            }
        });
    }

    return (<div className={"applications-list-wrapper"}>
        <div className={"applications-list-container"}>
            <div className="applications-list-body">

                <div style={{ width: '100%' }}>
                    <DataGrid
                        loading={loading}
                        rows={applications}
                        columns={columns}
                        pageSize={10}
                        autoHeight
                        disableSelectionOnClick
                        sx={dataGridStyles}
                        components={{
                            NoRowsOverlay: CustomNoRowsOverlay,
                            Pagination: CustomPagination
                        }}
                        componentsProps={{
                            pagination: { loading },
                        }}
                    />
                </div>
            </div>
        </div>
    </div>);
}

export default ApplicationsList;
